import { Stack, Typography } from "@mui/material";
import { HugeiconsIcon } from "@hugeicons/react";
import { CancelCircleIcon, CheckmarkCircle01Icon } from "@hugeicons/core-free-icons";

interface IPassword {
  title: string;
  validations: Array<{
    label: string;
    isValid: boolean;
  }>;
}

const Validator = ({ title, validations }: IPassword) => {
  return (
    <Stack spacing={1}>
      <Typography className="title">{title}</Typography>
      {validations.map((validation, index) => (
        <Stack spacing={2} direction={"row"} key={index}>
          {validation.isValid ? <HugeiconsIcon icon={CheckmarkCircle01Icon} color="#4CAF50" /> : <HugeiconsIcon icon={CancelCircleIcon} color="#F44336" />}
          <Typography className="label">{validation.label}</Typography>
        </Stack>
      ))}
    </Stack>
  );
};

export default Validator;
